export const formatDeviceLocation = (location?: string): string => {
  if (!location) return "-";

  try {
    const locationObj = JSON.parse(location);
    const parts = [];

    if (locationObj.city) {
      parts.push(locationObj.city);
    }

    if (locationObj.country) {
      parts.push(locationObj.country);
    }

    return parts.length > 0 ? parts.join(", ") : "-";
  } catch {
    return location || "-";
  }
};

export const transformDeviceLogin = (
  device: DeviceLogin,
): DeviceLogin & { formattedLocation: string } => ({
  ...device,
  formattedLocation: formatDeviceLocation(device.location),
});

export const formatUserAgent = (userAgent?: string): string => {
  if (!userAgent) return "-";

  // Get OS name
  let os = "Unknown OS";

  if (userAgent.includes("Mac OS X")) {
    os = "macOS";
  } else if (userAgent.includes("Windows")) {
    os = "Windows";
  } else if (userAgent.includes("Linux")) {
    os = "Linux";
  } else if (userAgent.includes("iOS")) {
    os = "iOS";
  } else if (userAgent.includes("Android")) {
    os = "Android";
  }

  // Get browser name
  let browser = "Unknown Browser";

  if (userAgent.includes("Chrome") && !userAgent.includes("Edg/")) {
    browser = "Chrome";
  } else if (userAgent.includes("Firefox")) {
    browser = "Firefox";
  } else if (userAgent.includes("Safari") && !userAgent.includes("Chrome")) {
    browser = "Safari";
  } else if (userAgent.includes("Edg/")) {
    browser = "Edge";
  } else if (userAgent.includes("OPR/")) {
    browser = "Opera";
  }

  return `${os} - ${browser}`;
};

import { type DeviceLogin } from "@vega-api/generated/types/deviceLogin";
